import { SortableContext, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { SellingColumn } from "../../../assets/utils/data/selling";
import { LittleHeadline, LittleText } from "../../typography";
import styled from "styled-components";
import { SellingStage, sellingStagesObj, SellingStyle } from "../../../assets/utils/enums/selling";
import { SortableCard } from "./kanban-board_card";
import { COLORS } from "../../../assets/utils/enums/colors";

export default function SortableColumn({ column }: { column: SellingColumn }) {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
        useSortable({
            id: `col-${column.title}`,   
        });

    const filteredTransform = (() => {
        if (!transform) return undefined;
        const { x, y } = transform;
        return `translate3d(${x}px, ${y}px, 0)`; // без scale взагалі
    })();

    // фікс масштабу
    const style: React.CSSProperties = {
        transform: filteredTransform,
        transition: isDragging ? transition : "transform 0ms",
    };



    //   const style: React.CSSProperties = {
    //     transform: filteredTransform,
    //     transition: transition ?? "transform 200ms ease",
    //   };

    return (
        <Column
            ref={setNodeRef}
            $colors={
                sellingStagesObj[column.title as SellingStage] ||
                sellingStagesObj[SellingStage.FIRST_CONTRACT]
            }
            style={style}
        >
            <ColumnHeader>
                <LittleHeadline>{column.title}</LittleHeadline>
                <span
                    className="d-flex"
                    {...listeners}
                    {...attributes}
                    tabIndex={-1}       // fix 2
                >
                    <svg
                        width="9"
                        height="14"
                        viewBox="0 0 9 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M0 1.3125C-5.13673e-09 1.14014 0.0339487 0.969468 0.099908 0.810228C0.165867 0.650988 0.262545 0.506299 0.384422 0.384422C0.506299 0.262545 0.650988 0.165867 0.810228 0.099908C0.969468 0.0339487 1.14014 0 1.3125 0C1.48486 0 1.65553 0.0339487 1.81477 0.099908C1.97401 0.165867 2.1187 0.262545 2.24058 0.384422C2.36245 0.506299 2.45913 0.650988 2.52509 0.810228C2.59105 0.969468 2.625 1.14014 2.625 1.3125C2.625 1.6606 2.48672 1.99444 2.24058 2.24058C1.99444 2.48672 1.6606 2.625 1.3125 2.625C0.964403 2.625 0.630564 2.48672 0.384422 2.24058C0.138281 1.99444 1.03741e-08 1.6606 0 1.3125ZM6.125 1.3125C6.125 0.964403 6.26328 0.630564 6.50942 0.384422C6.75556 0.138281 7.0894 0 7.4375 0C7.7856 0 8.11944 0.138281 8.36558 0.384422C8.61172 0.630564 8.75 0.964403 8.75 1.3125C8.75 1.6606 8.61172 1.99444 8.36558 2.24058C8.11944 2.48672 7.7856 2.625 7.4375 2.625C7.0894 2.625 6.75556 2.48672 6.50942 2.24058C6.26328 1.99444 6.125 1.6606 6.125 1.3125ZM0 6.99125C-5.13673e-09 6.81889 0.0339487 6.64822 0.099908 6.48898C0.165867 6.32974 0.262545 6.18505 0.384422 6.06317C0.506299 5.9413 0.650988 5.84462 0.810228 5.77866C0.969468 5.7127 1.14014 5.67875 1.3125 5.67875C1.48486 5.67875 1.65553 5.7127 1.81477 5.77866C1.97401 5.84462 2.1187 5.9413 2.24058 6.06317C2.36245 6.18505 2.45913 6.32974 2.52509 6.48898C2.59105 6.64822 2.625 6.81889 2.625 6.99125C2.625 7.33935 2.48672 7.67319 2.24058 7.91933C1.99444 8.16547 1.6606 8.30375 1.3125 8.30375C0.964403 8.30375 0.630564 8.16547 0.384422 7.91933C0.138281 7.67319 1.03741e-08 7.33935 0 6.99125ZM6.125 6.99125C6.125 6.64315 6.26328 6.30931 6.50942 6.06317C6.75556 5.81703 7.0894 5.67875 7.4375 5.67875C7.7856 5.67875 8.11944 5.81703 8.36558 6.06317C8.61172 6.30931 8.75 6.64315 8.75 6.99125C8.75 7.33935 8.61172 7.67319 8.36558 7.91933C8.11944 8.16547 7.7856 8.30375 7.4375 8.30375C7.0894 8.30375 6.75556 8.16547 6.50942 7.91933C6.26328 7.67319 6.125 7.33935 6.125 6.99125ZM0 12.6875C-5.13673e-09 12.5151 0.0339487 12.3445 0.099908 12.1852C0.165867 12.026 0.262545 11.8813 0.384422 11.7594C0.506299 11.6375 0.650988 11.5409 0.810228 11.4749C0.969468 11.4089 1.14014 11.375 1.3125 11.375C1.48486 11.375 1.65553 11.4089 1.81477 11.4749C1.97401 11.5409 2.1187 11.6375 2.24058 11.7594C2.36245 11.8813 2.45913 12.026 2.52509 12.1852C2.59105 12.3445 2.625 12.5151 2.625 12.6875C2.625 13.0356 2.48672 13.3694 2.24058 13.6156C1.99444 13.8617 1.6606 14 1.3125 14C0.964403 14 0.630564 13.8617 0.384422 13.6156C0.138281 13.3694 1.03741e-08 13.0356 0 12.6875ZM6.125 12.6875C6.125 12.3394 6.26328 12.0056 6.50942 11.7594C6.75556 11.5133 7.0894 11.375 7.4375 11.375C7.7856 11.375 8.11944 11.5133 8.36558 11.7594C8.61172 12.0056 8.75 12.3394 8.75 12.6875C8.75 13.0356 8.61172 13.3694 8.36558 13.6156C8.11944 13.8617 7.7856 14 7.4375 14C7.0894 14 6.75556 13.8617 6.50942 13.6156C6.26328 13.3694 6.125 13.0356 6.125 12.6875Z"
                            fill={
                                sellingStagesObj[column.title as SellingStage]?.txtColor ??
                                sellingStagesObj[SellingStage.FIRST_CONTRACT].txtColor
                            }
                        />
                    </svg>
                </span>
            </ColumnHeader>

            <CardsContainer>
                {column.items.length === 0 ? <LittleText>Немає елементів у цій колонці</LittleText> : <SortableContext
                    items={column.items.map((i) => `item-${i.id}`)}
                    strategy={verticalListSortingStrategy}
                >
                    {column.items.map((item) => (
                        <SortableCard key={item.id} item={item} />
                    ))}
                </SortableContext>}
            </CardsContainer>
        </Column>
    );
}

const ColumnHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 5px;
  margin-bottom: 8px;

  span {
    cursor: grab;
    margin-left: auto;
    user-select: none;
    transition: 0.2s;
    &:hover {
      color: rgba(0, 0, 0, 0.7);
      transform: scale(0.95);
    }
    &:active {
      cursor: grabbing;
      transform: scale(0.9);
    }
  }
`;

const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  max-height: 80vh;
  padding-right: 4px;

  ${LittleText} {
  color: ${COLORS.secondary1}}
`;


const Column = styled.div<{ $colors: SellingStyle }>`
  background: ${({ $colors }) => $colors.bgColor};
  border: 1px solid ${({ $colors }) => $colors.txtColor};
  border-radius: 4px;
  width: 330px;
flex: 0 0 330px;
  display: flex;
  flex-direction: column;
  height: fit-content;
  padding: 16px;
  padding-right: 6px;
  transition: transform 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);

  ${LittleHeadline} {
    color: ${({ $colors }) => $colors.txtColor};
  }

  ${ColumnHeader} {
    border-bottom: 1px solid ${({ $colors }) => $colors.txtColor};
  }

  ${CardsContainer} {
    scrollbar-width: thin;
    scroll-snap-type: y proximity;
    scrollbar-width: thin;
    scrollbar-color: ${({ $colors }) => $colors.txtColor}
      ${({ $colors }) => $colors.bgColor} !important;

    &::-webkit-scrollbar {
      width: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: transparent !important;
      border-radius: 50%;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }
`;
